<div class="ng-bento">
	<bento-alert [items]="alerts">
	</bento-alert>

	<div class="row">
		<div class="col-xs-12">
			<button class="btn btn-primary col-xs-1"
							(click)="launchModal(import)">Import</button>
		</div>
		<div class="col-xs-12 import-export-test-margin">
			<button class="btn btn-outline-primary col-xs-1"
							(click)="launchModal(export)">Export</button>
		</div>
		<div class="col-xs-12 import-export-test-margin">
			<button class="btn btn-outline-primary col-xs-1"
							(click)="getIdMapping()">View Id Mappings</button>
		</div>
	</div>

	<div class="row error-container">
		<div class="col-md-6">
			<div class="card"
					*ngIf="error">
				<h4 class="card-header">Errors</h4>
				<div class="card-body text-danger">
					{{error | json}}
				</div>
			</div>

			<div class="card"
					*ngIf="importResult?.ErrorBundles">
				<h4 class="card-header">Import Errors</h4>
				<div class="card-body">
					<ngb-accordion class="bento-accordion"
												close-others="false">
						<ngb-panel id="{{i}}"
											title="{{importError.DtoType}}"
											*ngFor="let importError of importResult.ErrorBundles; let i = index">
							<ng-template ngbPanelContent>
								<div class="row">
									<div class="col-xs-12"
											*ngFor="let errorMessage of importError.ErrorDtos">
										# {{importError.LineNumber}} - {{errorMessage.error.message}}
									</div>
								</div>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
			</div>
		</div>
	</div>

	<ng-template #import
							let-c="close"
							let-d="dismiss">
		<button type="button"
						class="close"
						aria-label="Close"
						(click)="d('close')"
						[disabled]="modalLoading">
			<i class="bento-icon-close-x"
				aria-hidden="true"></i>
		</button>
		<div class="modal-header">
			Import Data
		</div>
		<div class="modal-body"
				[bentoBusyLoader]="modalLoading">
			<h2>Select a file</h2>
			<bento-file-selector showSelectedFiles="true"
													multiple="false"
													[(ngModel)]="selectedFile"
													[disabled]="modalLoading">
			</bento-file-selector>
		</div>
		<div class="modal-footer">
			<button type="button"
							class="btn btn-primary"
							(click)="importFile()"
							[disabled]="modalLoading">Import</button>
			<button type="button"
							class="btn btn-outline-primary"
							(click)="c('close')"
							[disabled]="modalLoading">Cancel</button>
		</div>
	</ng-template>

	<ng-template #export
							let-c="close"
							let-d="dismiss">
		<button type="button"
						class="close"
						aria-label="Close"
						(click)="d('close')"
						[disabled]="modalLoading">
			<i class="bento-icon-close-x"
				aria-hidden="true"></i>
		</button>
		<div class="modal-header">
			What would you like to export?
		</div>
		<div class="modal-body modal-scroll"
				[bentoBusyLoader]="modalLoading">
			<div class="pb-3 mb-3 border-bottom">
				<bento-toggle name="all"
											[(ngModel)]="selectAll"
											(click)="toggleAll()"></bento-toggle>
				<label class="ml-2 font-weight-bold"
							for="all">Select All</label>
			</div>
			<div class="mb-3"
					*ngFor="let option of exportOptions">
				<bento-toggle name="{{option.type}}"
											[(ngModel)]="option.value"></bento-toggle>
				<label class="ml-2"
							for="{{option.type}}">{{option.name}}</label>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button"
							class="btn btn-primary"
							(click)="exportClose()"
							[disabled]="modalLoading">Export</button>
			<button type="button"
							class="btn btn-outline-primary"
							(click)="c('close')"
							[disabled]="modalLoading">Cancel</button>
		</div>
	</ng-template>
</div>
